import React from 'react';
import styled from 'styled-components';

import kindbody from '../../assets/logos/kindbody.svg';

const LogoLink = styled.a`
  position: fixed;
  right: 20px;
  top: 25px;
  z-index: ${({ theme }) => theme.layers.kindbodyLogo};
`;

const KindbodyLogo = () => {
  const isDashboard = window.location.pathname === '/';
  if (isDashboard) return null;

  return (
    <LogoLink href="/">
      <img src={kindbody} alt="kindbody" />
    </LogoLink>
  );
};

export default KindbodyLogo;
